export enum ACTIONS {
  FETCH_CARS = 'FETCH_CARS',
  FETCH_ROUTES = 'FETCH_ROUTES',
  GET_ROUTE_DIRECTION = 'GET_ROUTE_DIRECTION',
}
